import { AttachmentPreviewKind } from '../models/notification-attachment.model';

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp']);
const PDF_EXTENSIONS = new Set(['pdf']);
const WORD_EXTENSIONS = new Set(['doc', 'docx']);
const EXCEL_EXTENSIONS = new Set(['xls', 'xlsx']);

const MIME_TO_KIND: Record<string, AttachmentPreviewKind> = {
  'image/jpeg': 'image',
  'image/jpg': 'image',
  'image/png': 'image',
  'image/gif': 'image',
  'image/webp': 'image',
  'application/pdf': 'pdf',
  'application/msword': 'word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word',
  'application/vnd.ms-excel': 'excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel'
};

export function getExtension(fileName: string): string {
  if (!fileName) { return ''; }
  const parts = fileName.split('.');
  return parts.length > 1 ? (parts.pop() || '').toLowerCase() : '';
}

export function getPreviewKind(fileName: string, mimeType?: string): AttachmentPreviewKind {
  if (mimeType && MIME_TO_KIND[mimeType.toLowerCase()]) {
    const kind = MIME_TO_KIND[mimeType.toLowerCase()];
    if (kind === 'word' && getExtension(fileName) === 'doc') {
      return 'unsupported';
    }
    return kind;
  }

  const ext = getExtension(fileName);
  if (IMAGE_EXTENSIONS.has(ext)) { return 'image'; }
  if (PDF_EXTENSIONS.has(ext)) { return 'pdf'; }
  if (ext === 'docx') { return 'word'; }
  if (ext === 'doc') { return 'unsupported'; }
  if (EXCEL_EXTENSIONS.has(ext)) { return 'excel'; }
  return 'unsupported';
}

export function getFileTypeLabel(fileName: string, mimeType?: string): string {
  const kind = getPreviewKind(fileName, mimeType);
  const ext = getExtension(fileName).toUpperCase();
  if (ext) { return ext; }
  switch (kind) {
    case 'image': return 'Image';
    case 'pdf': return 'PDF';
    case 'word': return 'Word';
    case 'excel': return 'Excel';
    default: return 'File';
  }
}

export function getFileIconClass(fileName: string, mimeType?: string): string {
  const kind = getPreviewKind(fileName, mimeType);
  switch (kind) {
    case 'image': return 'icon-image';
    case 'pdf': return 'icon-file-text';
    case 'word': return 'icon-file-text';
    case 'excel': return 'icon-grid';
    default: return 'icon-file';
  }
}

export function formatFileSize(bytes?: number): string {
  if (bytes == null || bytes <= 0) { return ''; }
  if (bytes < 1024) { return `${bytes} B`; }
  if (bytes < 1024 * 1024) { return `${(bytes / 1024).toFixed(1)} KB`; }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
